import { useCompositeStoreProps as t } from "./B7UTNDHN.js";
import { useStore as u, useStoreProps as i } from "./RTNCFSKZ.js";
import { createRadioStore as a } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/radio/radio-store.js";
function m(o, r, e) {
  return o = t(o, r, e), i(o, e, "value", "setValue"), o;
}
function f(o = {}) {
  const [r, e] = u(a, o);
  return m(r, e, o);
}
export {
  f as useRadioStore,
  m as useRadioStoreProps
};
//# sourceMappingURL=BE2VUBZ4.js.map
